export class RecordIndexedDbRepo {
  constructor(db) {
    this.db = db;
  }

  get(id) {
    return this.db.records.get(id);
  }

  async put(recordId, record) {
    await this.db.records.put(record, recordId);
  }

  async delete(recordId) {
    await this.db.records.delete(recordId);
  }

  async clear() {
    await this.db.records.clear();
  }

  all() {
    return this.db.records.desc().toArray();
  }

  allIds() {
    return this.db.records.toCollection().desc().keys();
  }

  async getUpdateDate(recordId) {
    const record = await this.get(recordId);
    return record?.record.updateAt.date;
  }
}
